import React from 'react';
import { Sparkles, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24 md:pt-0"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_made-in-heaven/artifacts/oqx2ljq8_fbba0a65-6805-4f0e-8ef8-3171abef56c4.jpeg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/65 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-5xl mx-auto text-center space-y-6 md:space-y-8">
          
          {/* Top Tagline */}
          <div className="space-y-3 md:space-y-4">
            <div className="flex items-center justify-center space-x-2 text-amber-400 mb-6">
              <Sparkles size={20} className="flex-shrink-0 animate-pulse" />
              <span className="text-sm md:text-base lg:text-lg tracking-widest uppercase font-medium">
                Premium Event Planning in Vadodara, Gujarat
              </span>
              <Sparkles size={20} className="flex-shrink-0 animate-pulse" />
            </div>
            
            {/* Main Hero Title */}
            <h1 
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight px-4" 
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Creating Beautiful Celebrations<br className="hidden sm:block"/>
              <span className="text-amber-400">Without the Stress</span>
            </h1>
          </div>
          
          {/* Subheadline */}
          <p className="text-lg sm:text-xl md:text-2xl text-gray-100 max-w-4xl mx-auto leading-relaxed px-4 font-light">
            From weddings and engagements to birthdays and corporate events, Made in Heaven delivers thoughtful planning, smooth coordination, and memorable celebrations across Vadodara and Gujarat.
          </p>

          {/* Trust Strip */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm md:text-base text-amber-300 font-medium px-4">
            <span className="flex items-center gap-2">
              <CheckCircle2 size={20} className="flex-shrink-0" />
              12+ Years Experience
            </span>
            <span className="flex items-center gap-2">
              <CheckCircle2 size={20} className="flex-shrink-0" />
              500+ Events Managed
            </span>
            <span className="flex items-center gap-2">
              <CheckCircle2 size={20} className="flex-shrink-0" />
              End-to-End Planning
            </span>
          </div>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4 md:pt-6 px-4">
            <Button
              onClick={scrollToContact}
              className="w-full sm:w-auto bg-amber-600 hover:bg-amber-700 text-white px-10 py-7 text-base md:text-lg font-semibold transition-all duration-300 hover:scale-105 shadow-2xl rounded-full"
            >
              Book a Consultation
            </Button>
            <Button
              onClick={() => {
                const element = document.getElementById('gallery');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              variant="outline"
              className="w-full sm:w-auto border-2 border-white bg-white/10 backdrop-blur-sm text-white hover:bg-white hover:text-gray-900 px-10 py-7 text-base md:text-lg font-semibold transition-all duration-300 rounded-full"
            >
              View Our Work
            </Button>
          </div>

          {/* Secondary CTA Text */}
          <p className="text-white/80 text-sm md:text-base pt-2">
            Talk to our team • Get a quote • Plan your perfect event
          </p>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden md:block">
        <div className="w-6 h-10 border-2 border-white/60 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/60 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
